<template>
  <div v-if="paginator.current_page < paginator.total_pages" class="box" @click="$emit('loadMoreItems', paginator.current_page + 1)">
    <span v-if="loading" class="icon"><i class="fa fa-circle-o-notch fa-spin"></i></span>
    <span v-else>more</span>
  </div>
</template>

<script>
export default {
  props: {
    paginator: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../sass/variables'
@import '~bulma/sass/utilities/variables'
@import '~bulma/sass/utilities/mixins'

.box
  color: $text-light
  text-align: center
  padding: 1rem
  transition: color .3s
  font-weight: 300

  &:hover
    cursor: pointer
    color: $primary
</style>



// WEBPACK FOOTER //
// Paginator.vue?391d649d